import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import GlobalSearchOrderResults from "../GlobalSearchOrderResults/GlobalSearchOrderResults";
import GlobalSearchCarrierResults from "../GlobalSearchCarrierResults/GlobalSearchCarrierResults";

export default function GlobalSearchResults({
  isLoading,
  selectedSearchType,
  searchResults,
  searchInput,
  handleTableAction
}) {
  return (
    <Box>
      {isLoading ? (
        <Box sx={{ display: "flex", justifyContent: "center", marginTop: "50px" }}>
          <CircularProgress sx={{ color: "primary.60" }} size={50} />
        </Box>
      ) : (
        <Box>
          {searchResults.length > 0 &&
            (
              selectedSearchType === "order-id" ?
                <GlobalSearchOrderResults searchResults={searchResults} searchInput={searchInput} handleTableAction={handleTableAction} />
                : selectedSearchType === "carrierName" || selectedSearchType === "mcNumber" || selectedSearchType === "dotNumber" ?
                  <GlobalSearchCarrierResults searchResults={searchResults} searchInput={searchInput} selectedSearchType={selectedSearchType} handleTableAction={handleTableAction} />
                  : <></>
            )}
        </Box>
      )}

    </Box>
  );
}

GlobalSearchResults.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  selectedSearchType: PropTypes.string.isRequired,
  searchResults: PropTypes.array.isRequired,
  searchInput: PropTypes.string.isRequired,
  handleTableAction: PropTypes.func
};